import React, { useState, useEffect } from "react";
import { PropsData } from "../../../context";
import { Modal, Typography, Button, COLORS, TermsCheckbox, Loader} from "@virkesborsen/ui-component-library";
import { CharcoalTypography,ContentContainer } from "./utils/utils";
import { generateForestandProperty } from "../../../../../api/services/property";

export const ForestRequirementStep = ({ currentStepIndex, totalSteps, handleBack, handleNext, handleClose, arbonicsData, updateCo2Deal}) => {
  const propsContext = React.useContext(PropsData);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
      setIsLoading(true)
      if (arbonicsData.selectedProp.dfr){
        await updateCo2Deal({
          stage:"arbonics",
          comments: "sent to arbonics"
        })

        arbonicsData.forestand_data_req.append('arbonics', true)
        const resp = await generateForestandProperty(arbonicsData.forestand_data_req)

        gtag("event", "fe_co2_success" + currentStepIndex.toString(), {
          method: "site"
        });
        handleNext({
          arbonicsData: {  },
        });
      }
      else{
        window.location.href = "/min-skog/?view=overvakning"
      }
    
  };

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Typography variant="bodyMediumBaseRegular">
          Vänta...
        </Typography>
        <Loader />
      </div>
    );
  }

  return (
    <>
      <Modal.Content>
        <ContentContainer>
          <Typography variant="subheaderSmallMedium">Grattis! Din fastighet ser ut att uppfylla kraven för kolkrediter.</Typography>
          {arbonicsData.selectedProp.dfr?<> <Typography variant="bodySmallRegular" className="neutral-pebble">Din skog uppfyller de grundläggande kriterier som krävs för att kunna skickas in till analys.</Typography>
          <Typography variant="bodySmallRegular" className="neutral-pebble"> Det betyder att du är ett steg närmare att kunna generera intäkter från dina kolbindande insatser.</Typography>
          <Typography variant="bodySmallRegular" className="neutral-pebble"> Du har möjlighet att förlänga omloppstiden på cirka <span className="fw-medium"> {Number(arbonicsData.sbo.arbonics.ha).toLocaleString()} </span> hektar skog på din fastighet <span className="fw-medium">{arbonicsData.selectedProp.designation} </span>och därigenom tjäna kolkrediter – till ett estimerat värde av <span className="fw-medium">{Number(arbonicsData.sbo.arbonics.price).toLocaleString()} SEK. </span></Typography>
          <Typography variant="bodySmallRegular" className="neutral-pebble"> Observera att detta är estimerade siffror och att det faktiska värdet kan komma att justeras i samband med offerten.</Typography></>:<>
          <Typography variant="bodySmallRegular" className="neutral-pebble">En preliminär analys av din Forestand-fil visar att skogen uppfyller de grundläggande kriterier som krävs för att kunna gå vidare till offert.</Typography>
          <Typography variant="bodySmallRegular" className="neutral-pebble"> Det innebär att du är ett steg närmare att kunna generera intäkter från dina kolbindande åtgärder.</Typography>
          <Typography variant="bodySmallRegular" className="neutral-pebble"> Analysen tyder på att du har möjlighet att förlänga omloppstiden på cirka <span className="fw-medium"> {Number(arbonicsData.sbo.arbonics.ha).toLocaleString()} </span> hektar skog på din fastighet <span className="fw-medium">{arbonicsData.selectedProp.designation}, </span>vilket potentiellt kan ge kolkrediter till ett estimerat värde av <span className="fw-medium">{Number(arbonicsData.sbo.arbonics.price).toLocaleString()} SEK. </span></Typography>
          <Typography variant="bodySmallRegular" className="neutral-pebble"> Observera att detta endast är en preliminär bedömning. En säkerställd analys kan göras när du köper vår tjänst för skogsövervakning och skickar in ditt intresse.</Typography></>}
          <TermsCheckbox
            errorText="This is an error"
            label="Jag är säker på att planen som är genererad följer verkligheten väl."
            name="terms"
            onClick={(val) => { setAcceptedTerms(val)}}
          />
        </ContentContainer>
      </Modal.Content>
      <Modal.Footer>
        <Button
          fullWidth
          variant="primary"
          disabled={!acceptedTerms}
          onClick={handleSubmit}
          label={arbonicsData.selectedProp.dfr ?"Nästa steg":"Köp skogsövervakning"}
          suffixIcon={"arrowRightSimple"}
        />
      </Modal.Footer>
    </>
  );
};

